import { Inject, Injectable, Optional } from "@angular/core";
import { DwActionHandler, DwModalService, DwMenuService, DwMetaDataGridActionState, DwActionResult, DwAction, DwActionType, DwModalConfig, DwImportMetaDataModalComponent, DwModalButtonStandardConfigs, DwGridActionResult, DwRoutingService, DwModalSize, ensureArray, DwMetaDataFormStateService, DwMetaDataFormApi, DwEventService, DwGridEvents, DwMetaDataRoutingService, DwMenuActionType, DwModalResult, DwOrmDataServiceToken, DwOrmDataService } from "@devwareapps/devware-cap";
import { Observable, of } from "rxjs";
import { AIProcessingReferenceEntity, AIProcessingReferenceStatusAllItems, AppMetaData, AppMetaDataItemNames, CourseLessonEntity } from "../../../meta-data/app-meta-data.service";
import { map, mergeMap } from "rxjs/operators";

@DwAction({
    keyName: 'start-ai-processing',
    display: 'Start AI Processing',
    actionType: DwActionType.gridContextMenuAction,
    parentItemName: AppMetaDataItemNames.CourseLesson,
    isGlobal: false,
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Start AI Processing',
        iconClass: '',
        buttonClass: 'btn btn-warning',
        buttonTitle: 'Start AI Processing'
    },
    defaultSecurityConfig: {
        requireAuthentication: true,
        useEmulatedPermissions: true,
        // permissionMeaning: DwSecurityPermissions.AdminCanAccess,
        requireCanUpdate: true
    }
})
@Injectable()
export class StartAiProcessingActionService implements DwActionHandler {
    formApi: DwMetaDataFormApi;

    constructor(
        private dwModalService: DwModalService,
        private dwMenuService: DwMenuService,
        private dwRoutingService: DwRoutingService,
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        @Optional() private dwFormStateService: DwMetaDataFormStateService,
        private dwEventService: DwEventService
    ) {
        this.formApi = this.dwFormStateService?.state?.formApi;
    }

    handleAction(actionState: DwMetaDataGridActionState<any>): Observable<DwActionResult> {

        const data: CourseLessonEntity[] = ensureArray(actionState.data);

        const aiProcessingReferences: AIProcessingReferenceEntity[] = [];

        for (const item of data) {
            let aiProcessingReference: Partial<AIProcessingReferenceEntity> = AppMetaData.AIProcessingReference.CreateEntity();

            aiProcessingReference.AIProcessingReferenceId = item.AIProcessingReferenceId,
                aiProcessingReference.AIProcessingStatusId = AIProcessingReferenceStatusAllItems.Reprocess

            if (!item.AIProcessingReferenceId) {
                aiProcessingReference.MetaDataItemId = AppMetaData.CourseLesson.ItemDetail.itemId;
                aiProcessingReference.KeyValue = item.CourseLessonId;
            }

            aiProcessingReferences.push(aiProcessingReference as AIProcessingReferenceEntity);
        }

        if (aiProcessingReferences.length === 0) {
            return of({
                success: false,
                message: 'No valid items to process.'
            } as DwActionResult);
        }

        return this.dataService.saveEntityCollection(aiProcessingReferences)
            .pipe(mergeMap(savedReferences => {
                const lessonsToSave: CourseLessonEntity[] = [];

                for (const reference of savedReferences) {
                    const lesson = data.find(l => l.CourseLessonId === reference.KeyValue);
                    if (lesson && !lesson.AIProcessingReferenceId) {
                        lesson.AIProcessingReferenceId = reference.AIProcessingReferenceId;
                        lessonsToSave.push(lesson);
                    }
                }

                if (lessonsToSave.length === 0) {
                    return of({
                        success: true,
                        message: 'AI processing started successfully.',
                        refreshData: true
                    } as DwActionResult);
                }

                return this.dataService.saveEntityCollection(lessonsToSave).pipe(map(() => {
                    return {
                        success: true,
                        message: 'AI processing started successfully.',
                        refreshData: true
                    } as DwGridActionResult;
                }));
            }));
    }
}